import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import AuthCallback from "./pages/AuthCallback";
import Home from "./pages/Home";
import CandidateLanding from "./pages/CandidateLanding";
import EmployerLanding from "./pages/EmployerLanding";
import SignIn from "./pages/SignIn";
import CandidateSignUp from "./pages/CandidateSignUp";
import EmployerSignUp from "./pages/EmployerSignUp";
import CandidateDashboard from "./pages/candidate/CandidateDashboard";
import Onboarding from "./pages/candidate/Onboarding";
import CandidateDocuments from "./pages/candidate/CandidateDocuments";
import EmployerDashboard from "./pages/employer/EmployerDashboard";
import SubmitRole from "./pages/employer/SubmitRole";
import Shortlist from "./pages/employer/Shortlist";
import EmployerDocuments from "./pages/employer/EmployerDocuments";
import Partnership from "./pages/employer/Partnership";
import CVReview from "./pages/CVReview";
import CityPage from "./pages/CityPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Admin from "./pages/Admin";
import MeetTheTeam from "./pages/MeetTheTeam";
import Jobs from "./pages/Jobs";
import JobDetail from "./pages/JobDetail";
import EliteIntake from "./pages/EliteIntake";
import ShortlistUnavailable from "./pages/ShortlistUnavailable";
import Maintenance from "./pages/Maintenance";
import { LeadCaptureDialog } from "./components/LeadCaptureDialog";

// Site-wide maintenance switch — set to false to bring the whole app back online.
const MAINTENANCE_MODE = false;

function AppRouter() {
  const location = useLocation();
  if (MAINTENANCE_MODE) return <Maintenance />;
  // Synchronous hash check — session_id must be processed before any auth checks
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <LeadCaptureDialog />
    <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/candidates" element={<CandidateLanding />} />
          <Route path="/employers" element={<EmployerLanding />} />
          <Route path="/team" element={<MeetTheTeam />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          {/* Candidate discovery temporarily taken down — restore by pointing these back to <ShortlistDiscovery /> */}
          <Route path="/discovery" element={<ShortlistUnavailable />} />
          <Route path="/shortlist" element={<ShortlistUnavailable />} />
          <Route path="/register" element={<EliteIntake />} />
          <Route path="/cv-review" element={<CVReview />} />
          <Route path="/recruiting/:slug" element={<CityPage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/signup/candidate" element={<EliteIntake />} />
          <Route path="/signup/employer" element={<EmployerSignUp />} />
          <Route path="/candidate" element={<ProtectedRoute role="candidate"><CandidateDashboard /></ProtectedRoute>} />
          <Route path="/candidate/onboarding" element={<ProtectedRoute role="candidate"><Onboarding /></ProtectedRoute>} />
          <Route path="/candidate/documents" element={<ProtectedRoute role="candidate"><CandidateDocuments /></ProtectedRoute>} />
          <Route path="/employer" element={<ProtectedRoute role="employer"><EmployerDashboard /></ProtectedRoute>} />
          <Route path="/employer/submit-role" element={<ProtectedRoute role="employer"><SubmitRole /></ProtectedRoute>} />
          <Route path="/employer/shortlist" element={<ProtectedRoute role="employer"><Shortlist /></ProtectedRoute>} />
          <Route path="/employer/documents" element={<ProtectedRoute role="employer"><EmployerDocuments /></ProtectedRoute>} />
          <Route path="/employer/partnership" element={<ProtectedRoute role="employer"><Partnership /></ProtectedRoute>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
